export const CHANGE_PASSWORD_MESSAGES = {
  INVALID_TOKEN:
    "This reset password link has already been used or is expired, please request a new password link."
};
